import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { convertToRaw, ContentState, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "../../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const CoreIssue = (props) => {
  let handleChange = (opts, e) => {
    const html = draftToHtml(convertToRaw(e.getCurrentContent()));
    let event = {
      target: {
        value: html,
      },
    };
    props.handleChange(opts, event);
  };

  const defaultText = "Core issue for this course...";
  const key = "core_issue";
  let initContent;

  try {
    /* NOTE: using the html-to-draftjs module here because it is
     * designed to work with react-draft-wysiwyg.
     * The native draft-js conversion method has issues with
     * images, subscripts, etc...
     */
    let blocksFromHTML = htmlToDraft(props.text);
    /**
     * NOTE: We have to get the raw content state from the EditorState, because
     *       the ContentState created from the blocks array is missing some
     *       variable definitions expected by the Editor that are given default values
     *       by EditorState.createWithContent(). This might be something we can also solve
     *       by configuring the editor differently, but for now, this works.
     **/
    initContent = convertToRaw(
      EditorState.createWithContent(
        ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap
        )
      ).getCurrentContent()
    );
  } catch (e) {
    initContent = props.text;
  }

  const text =
    props.focusKey == key ? (
      <Editor
        wrapperId={key + "input"}
        wrapperClassName="w-100"
        onEditorStateChange={(e) =>
          handleChange(
            {
              type: "core_issue",
            },
            e
          )
        }
        initialContentState={initContent}
        readOnly={false}
        placeholder={defaultText}
      />
    ) : (
      <Editor
        wrapperId={key + "input"}
        wrapperClassName="w-100"
        toolbarHidden={true}
        readOnly={true}
        contentState={initContent}
        placeholder={defaultText}
      />
    );

  return (
    <div
      id={key}
      className="table table-bordered inner-buffer sm-font"
      style={{ minHeight: "8rem" }}
      onClick={(e) => props.focus(key, e)}
    >
      {props.dataReady ? text : <div className="spinner"></div>}
    </div>
  );
};

export default CoreIssue;
